import { http } from '../core/http';

/**
* 订单 / 商品统计数据
* @export
* @param {Object} params - 
* @param {number} params.source - 统计来源 2:商品销售 4:订单统计
* @param {number} params.type - 统计类型 1:今日 2:本周 3:本月
* @param {number} [params.source_from=2]
* @param {number} [params.order_from=1]
* @param {number} [params.ziuid]
* @returns
*/
export async function getOrderStatistics({
  source,
  type,
  source_from,
  order_from,
  ziuid ,
}: {
  source: number,
  type: number,
  source_from?: number,
  order_from?: number,
  ziuid?: number,
}): Promise<any> {
  const payload: any = {
    source,
    type,
    ziuid,
  }
  if (source_from !== undefined) payload.source_from = source_from
  if (order_from !== undefined) payload.order_from = order_from
  // 只有当 ziuid 有值时才添加到 payload 中
  if (ziuid !== undefined && ziuid !== null) {
    payload.ziuid = ziuid
  }
  return await http.post('/index.php?route=vapi/index/getOrderStatisticsData', payload);
}

/**
* 订单来源列表
* @export
* @param {Object} [params] - 
* @returns
*/
export async function getOrderSource(): Promise<any> {
  return await http.post('/index.php?route=vapi/index/getOrderSource');
}


/**
* 获取个人统计数据
* @export
* @param {Object} params
* @param {number|string} [params.ziuid]
* @param {number|string} [params.source]
* @param {string} [params.start_time]
* @param {string} [params.end_time]
* @param {number|string} [params.order_from]
* @param {number|string} [params.source_from]
* @returns
*/
export async function getPersonalStatistics({
  ziuid = '',
  source = '',
  start_time = '',
  end_time = '',
  order_from = '',
  source_from = '',
}: {
  ziuid?: number | string,
  source?: number | string,
  start_time?: string,
  end_time?: string,
  order_from?: number | string,
  source_from?: number | string,
} = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/index/getPersonalStatistics', {
    ziuid,
    source,
    start_time,
    end_time,
    order_from,
    source_from,
  });
}

/**
* 修改订单商品销售额
* @export
* @param {Object} params
* @param {number|string} params.order_product_id - 订单商品ID
* @param {number} params.money - 修改后的金额
* @returns
*/
export async function updateSalesMoney({
  order_product_id,
  money,
}: {
  order_product_id: number | string,
  money: number,
}): Promise<any> {
  return await http.post('/index.php?route=vapi/index/updateSalesMoney', {
    order_product_id,
    money,
  });
}
